// SPURS.config.js
module.exports = {
  
  // options...
  version: 'spurs@0.1.0',
  toolName: 'SPURS',

  // Popup
  maxNumberOfDriversShown: 10,

  // The maximum number of samples that get randomly selected and used for the preview density and the highlight density
  // These densities in turn get also used for the KL 
  maxNumberOfSamplesUsedInPreviewAndForKLDivergence: 10000

}
